import i18n from 'modules/core/lib/i18n'

import Period from 'modules/attendance/store/models/Period'
import type { Status } from 'modules/attendance/store/models/Period'

export default function stateToLabel(state: Status) {
  switch (state) {
    case Period.STATUS.approved:
      return i18n.t('time_tracking.states.approved.title')

    case Period.STATUS.pending:
      return i18n.t('time_tracking.states.pending.title')

    case Period.STATUS.in_progress:
      return i18n.t('time_tracking.states.in_progress.title')

    default:
      throw Error(`Invalid state ${state}`)
  }
}
